// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1lzF-","head":"ProcedureTableInfo_head__3Ii-N"};